export enum BotFeedbackOption {
    None = "None",
    ChatWithRep = "ChatWithRep",
    EmailUs = "EmailUs",
    LeaveFeedback = "LeaveFeedback",
}
